import React from 'react';
export function VideoIcon(props: SVGProps<SVGSVGElement>) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-160">
      <rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18" data-id="element-161" />
      <line x1="7" y1="2" x2="7" y2="22" data-id="element-162" />
      <line x1="17" y1="2" x2="17" y2="22" data-id="element-163" />
      <line x1="2" y1="12" x2="22" y2="12" data-id="element-164" />
      <line x1="2" y1="7" x2="7" y2="7" data-id="element-165" />
      <line x1="2" y1="17" x2="7" y2="17" data-id="element-166" />
      <line x1="17" y1="17" x2="22" y2="17" data-id="element-167" />
      <line x1="17" y1="7" x2="22" y2="7" data-id="element-168" />
    </svg>;
}